import { StoreActionType as Type } from "../../types";
import { FETCH_LEFT_MENU_SUCCESS, FETCH_LEFT_MENU_REQUEST, FETCH_LEFT_MENU_FAILURE } from "../../actions/getLeftMenuActions/_getLeftMenuActions";

export interface MenuItem {
    text: string;
    iconName?: string;
    navigateViewUrl?: string;
    isHidden?: boolean;
    items?: {
        menuItem: MenuItem[];
    };
}

export interface MenuContentState {
    menuItem: MenuItem[];
    loading: boolean;
    error: any;
}

const initialState: MenuContentState = {
    menuItem: [],
    loading: false,
    error: null
};

export const menuContentReducer = (
    state: MenuContentState = initialState,
    action: any
): MenuContentState => {
    switch (action.type) {
        case FETCH_LEFT_MENU_REQUEST:
            return {
                ...state,
                loading: true,
                error: null
            };
            
        case FETCH_LEFT_MENU_SUCCESS:
            console.log('Menu Content Reducer - Received Data:', action.payload);
            return {
                ...state,
                loading: false,
                menuItem: action.payload,
                error: null
            };
            
        case FETCH_LEFT_MENU_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload
            };
            
        case Type.SET_MENU_CONTENT:
            return {
                ...state,
                menuItem: action.info?.menuItem || state.menuItem
            };

        default:
            return state;
    }
};
